import React, { useLayoutEffect } from 'react';
import {
  useSearchParamsMethods,
  useSearchParamsSelector,
} from '../../../../shared/packages/searchParamsManager';
import {
  searchParamKeys,
  views,
  defaultView,
  searchParamSelectors,
} from '../../../../shared/configs/searchParams';

const { view: viewKey } = searchParamKeys;

const ViewGuard = ({ children }) => {
  const view = useSearchParamsSelector(searchParamSelectors[viewKey]);

  const { setParams } = useSearchParamsMethods();

  const viewValid = Boolean(view) && views.includes(view);

  useLayoutEffect(() => {
    if (!viewValid) {
      setParams({ [viewKey]: defaultView });
    }
  }, [viewValid, setParams]);

  return viewValid ? <>{children}</> : null;
};

export default ViewGuard;
